<template>
  <div>
    <TeaserSitecore jsonFileName="teaser5"></TeaserSitecore>
    <TeaserSitecore jsonFileName="teaser6"></TeaserSitecore>
    <TeaserSitecore jsonFileName="teaser7"></TeaserSitecore>
  </div>
</template>

<script setup lang="ts">
import TeaserSitecore from '@/components/rahmen/TeaserSitecore.vue'
</script>
